import { createSelector } from 'reselect'
import viewPropertiesSelector from './viewPropertiesSelector'

const modelsPageFiltersEnabledSelector = createSelector(
    viewPropertiesSelector,
    (viewProperties): boolean => viewProperties?.['showModelPageFilters'] === 'true',
)

export default modelsPageFiltersEnabledSelector